module.exports = __webpack_public_path__ + "static/media/qty-minus.eb4e15b7.svg";